import * as React from 'react'
import { memo } from 'react'
const SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
    <path
      fill="#0E4F26"
      d="M12 2a5.03 5.03 0 0 1 3.536 1.447A4.912 4.912 0 0 1 17 6.941c0 1.31-.527 2.567-1.464 3.494A5.03 5.03 0 0 1 12 11.882a5.03 5.03 0 0 1-3.536-1.447A4.912 4.912 0 0 1 7 6.941c0-1.31.527-2.567 1.464-3.494A5.03 5.03 0 0 1 12 2Zm0 11.353c5.525 0 10 2.211 10 4.941v1.714a.956.956 0 0 1-.732.94A42.208 42.208 0 0 1 12 22c-4.256 0-7.797-.707-9.268-1.052a.956.956 0 0 1-.732-.94v-1.714c0-2.73 4.475-4.941 10-4.941Z"
    />
  </svg>
)
const Memo = memo(SvgComponent)
export default Memo
